import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import { Tr } from 'Components/Table/Tr'

let RedirectRow = ({ children, redirectTo, stopPropagationClasses }) => (
  <Tr onClickHandler={redirectTo} clickable>
    {React.Children.map(children, child =>
      React.cloneElement(child, {
        onClick: e => {
          if (child.props.actions) {
            e.stopPropagation()
            e.preventDefault()
          }
        },
      }),
    )}
  </Tr>
)

const mapDispatchToProps = (dispatch, { to }) => ({
  redirectTo: () => to && dispatch(push(to)),
})

RedirectRow = connect(
  null,
  mapDispatchToProps,
)(RedirectRow)
export { RedirectRow }



// WEBPACK FOOTER //
// ./src/Containers/RedirectRow/index.js